import React, { useEffect, Fragment, useState } from "react";
import { Button, ButtonGroup, Grid } from "@material-ui/core";
import { useSelector, useDispatch } from "react-redux";
import dashboardActions from "../../../redux/actions/dashboard";
import { DatePicker } from "@material-ui/pickers";

export default function Dates() {
  const dashboard = useSelector((state) => state.dashboard);
  const app = useSelector((state) => state.app);
  const dispatch = useDispatch();

  const now = new Date();
  const [startDate, setStartDate] = useState(new Date(now.getFullYear(), now.getMonth(), 1));
  const [endDate, setEndDate] = useState(new Date(now.getFullYear(), now.getMonth() + 1, 1));

  useEffect(() => {
    let dates = {
      dateInit: null,
      dateFinish: null,
    };
    const now = new Date();
    if (dashboard.dateRange === "CURRENT") {
      dates = {
        dateInit: new Date(now.getFullYear(), now.getMonth(), 1),
        dateFinish: new Date(now.getFullYear(), now.getMonth() + 1, 1),
      };
      dispatch(dashboardActions.setDates(dates));
    }
    if (dashboard.dateRange === "PREVIUS") {
      dates = {
        dateInit: new Date(now.getFullYear(), now.getMonth() - 1, 1),
        dateFinish: new Date(now.getFullYear(), now.getMonth(), 1),
      };
      dispatch(dashboardActions.setDates(dates));
    }
  }, [dashboard.dateRange]);

  const setDate = ({ date, type }) => {
    dispatch(
      dashboardActions.setDates({
        ...dashboard.dates,
        [type]: new Date(date),
      })
    );
  };

  const searchByDate = () => {
    let dates = {
      dateInit: new Date(startDate),
      dateFinish: new Date(endDate),
    };
    dispatch(dashboardActions.setDates(dates));
  }

  return (
    <Fragment>
      <Grid container spacing={2} justify="flex-end">
        <Grid item>
          <ButtonGroup size="small" variant="contained">
            <Button
              onClick={() => dispatch(dashboardActions.setDateRange("RANGE"))}
              color={dashboard.dateRange === "RANGE" ? "primary" : "secondary"}
            >
              seleccionar rango
            </Button>
            <Button
              onClick={() => dispatch(dashboardActions.setDateRange("PREVIUS"))}
              color={
                dashboard.dateRange === "PREVIUS" ? "primary" : "secondary"
              }
              disabled={app.loading}
            >
              mes anterior
            </Button>
            <Button
              onClick={() => dispatch(dashboardActions.setDateRange("CURRENT"))}
              color={
                dashboard.dateRange === "CURRENT" ? "primary" : "secondary"
              }
              disabled={app.loading}
            >
              mes actual
            </Button>
          </ButtonGroup>
        </Grid>
      </Grid>
      {dashboard.dateRange === "RANGE" && (
        <Grid container spacing={2} justify="flex-end">
          <Grid item>
            <DatePicker
              inputVariant="outlined"
              margin="dense"
              label="Fecha inicial"
              value={startDate}
              maxDate={dashboard.dates.dateFinish}
              disableFuture
              onChange={(date) => setStartDate(date)}
            />
          </Grid>
          <Grid item>
            <DatePicker
              inputVariant="outlined"
              margin="dense"
              label="Fecha final"
              value={endDate}
              minDate={dashboard.dates.dateInit}
              onChange={(date) => setEndDate(date)}
            />
          </Grid>
          <Grid item>
            <Button
              onClick={searchByDate}
              color="primary"
              disabled={app.loading}
              style={{marginTop: "10px"}}
              variant="contained"
            >
              BUSCAR
            </Button>
          </Grid>
        </Grid>
      )}
    </Fragment>
  );
}
